import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { PrescriptionMessageT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchDeletePrescription } from '../api/deletePrescription.js';
import { rxKeys } from './keys.js';

export interface DeletePrescriptionVariables {
  dosespotPrescriptionId: string;
  userId?: string;
}

export function useDeletePrescriptionMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'prescriptions', 'delete'],
    mutationFn: async ({
      dosespotPrescriptionId,
    }: DeletePrescriptionVariables): Promise<PrescriptionMessageT> => {
      return await fetchDeletePrescription(dosespotPrescriptionId);
    },
    onSuccess: async (_data, variables) => {
      if (!variables.userId) return;

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: rxKeys.patientPrescriptions(variables.userId) }),
        queryClient.invalidateQueries({
          queryKey: rxKeys.prescription(variables.userId, variables.dosespotPrescriptionId),
        }),
        queryClient.invalidateQueries({
          queryKey: rxKeys.prescriptionLogs(variables.userId, variables.dosespotPrescriptionId),
        }),
      ]);
    },
  });
}
